exports.email = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i
exports.emailStr = '/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,6}$/i'

// ./src/shared/patterns/email.pattern.jsx
//   Line 1:26:  Unnecessary escape character: \.  no-useless-escape
//   Line 1:30:  Unnecessary escape character: \+  no-useless-escape
//   Line 1:32:  Unnecessary escape character: \-  no-useless-escape
//   Line 1:44:  Unnecessary escape character: \.  no-useless-escape
//   Line 1:46:  Unnecessary escape character: \-  no-useless-escape
